export const  sizeType = ["small", "medium", "large"]

export const algorithmOptions = [
    { label: "BFS", value: "BFS" },
    { label: "DFS", value: "DFS" },
    { label: "DIJKSTRA", value: "DIJKSTRA" },
    { label: "Flood Fill", value: "Flood Fill" },
  ];
  
export const gridOptions = [
    { label: "blank", value: "Hard" },
    { label: "remove color", value: "removeColor" },
    { label: "add maze", value: "Maze" },
  ];